/**
 * Root sort helpers. Authenticated MAIN uses Flarum's native Latest default.
 * These helpers intentionally no longer inject sort=top.
 */

export function isRootDiscussionPath(pathname) {
  const normalized = String(pathname || '/').replace(/\/+$/, '') || '/';
  return normalized === '/';
}
export function hasSearchQuery(params) {
  if (params === void 0) {
    params = {};
  }
  const query = params.q;
  return typeof query === 'string' ? query.trim() !== '' : Boolean(query);
}

/** @deprecated Retained for import stability; no longer forces a root sort. */
export const DEFAULT_ROOT_SORT = null;
export function withDefaultRootSort(params, pathname) {
  if (params === void 0) {
    params = {};
  }
  if (pathname === void 0) {
    pathname = '/';
  }
  return params;
}
export function withRootSortOrder(sortMap, params, pathname) {
  if (sortMap === void 0) {
    sortMap = {};
  }
  if (params === void 0) {
    params = {};
  }
  if (pathname === void 0) {
    pathname = '/';
  }
  return sortMap;
}
flarum.reg.add('flatrate-forum-navigation', 'forum/utils/defaultRootSort', { isRootDiscussionPath: isRootDiscussionPath,hasSearchQuery: hasSearchQuery,DEFAULT_ROOT_SORT: DEFAULT_ROOT_SORT,withDefaultRootSort: withDefaultRootSort,withRootSortOrder: withRootSortOrder, });